import Product from './product';

export interface CartItem extends Product {
  cartItemId: number;
  quantity: number;
  mlUsed?: number;
  mlSavings?: number;
  skuCp?: number;
  gst?: string;
  pincode?: number;
  attributes?: attributType[];
}

export type ShippingDataType = {
  itemId: number;
  isServiceable: boolean;
  expectedDeliveryDays: number;
  deliveryMessage?: string;
};

export type GiftDetailsType = {
  isApplicable: boolean;
  title: string;
  subtitle: string;
  inCart: boolean;
  logo: string;
  amountLeft: number;
  cta?: string;
};
export interface GiftItemType extends Product {
  giftDetails: GiftDetailsType;
}

export type attributType = {
  title: string;
  value: string;
};

export enum AddToCartType {
  ProductCard,
  ProductDescription,
}

export type StripDataType = {
  icon: string;
  text: string;
};

export type GiftSectionType = {
  title: string;
  giftItems: GiftItemType[];
};
interface Cart {
  cartId: string;
  totalCartValue: number;
  isVirtual: number;
  data: CartItem[];
  hasPriceChanged: boolean;
  oldCartPrice: number;
  newCartPrice: number;
  lastSelectedProductSku?: string;
  giftSection?: GiftSectionType;
  stripData?: StripDataType;
}

export default Cart;

export type CartPromoData = {
  title: string;
  expiry: string;
  promoCode: string;
};